import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

const Page = () => <Index toolKey="roadmap" routeLang="en" />;

export const Route = createFileRoute("/en/retail-roadmap")({
  head: () => publicToolHead("roadmap", "en"),
  component: Page,
  errorComponent: Page,
  notFoundComponent: Page,
});
